import { logMetrics } from './metrics';

try {
  logMetrics();
} catch (e) {
  //do nothing, we do not want to risk breaking a users app in anyway.
}
